import URL from "../api_url";

export const TEMPLATE_API = `${URL}/template`;
